import isEmpty from 'lodash/isEmpty'

import { CacheService } from './cache.service'

const STORAGE_NAME = 'mage-cache-storage'
const CACHE_SESSID_KEY = 'mage-cache-sessid'

export class MainService extends CacheService {
  constructor(gaApp) {
    super(gaApp, STORAGE_NAME, CACHE_SESSID_KEY)
  }

  initCacheStorage() {
    try {
      this.init()
    } catch (error) {
      console.error(error)
    }
  }

  getServerData(key) {
    if (typeof window === 'undefined') {
      return null
    }

    const storage = window.serverCache ?? {}
    let dataKey = null

    if (!isEmpty(storage[key])) {
      dataKey = storage[key]

      delete window.serverCache[key]

      return dataKey
    }

    return null
  }
}
